import { render, staticRenderFns } from "./ListaPromociones.vue?vue&type=template&id=3e9a9b38&scoped=true"
import script from "./ListaPromociones.vue?vue&type=script&lang=js"
export * from "./ListaPromociones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a9b38",
  null
  
)

export default component.exports